import fetchAPI from '../fetchAPI';

export const callResetTablePreferences = async (
  tableName: string
): Promise<iResponse<unknown>> => {
  const response: iResponse<unknown> = await fetchAPI({
    method: `DELETE`,
    route: `user/preferences/tables/${encodeURIComponent(tableName)}`
  });

  return response;
};

export default callResetTablePreferences;
